<template>
  <!-- <template v-if="slides.length"> -->
    <router-view />
    <MemberFullscreenModal
      v-model="memberFullscreenVisible"
      :member-type="memberFullscreenType"
      :select-duration="memberFullscreenSelectDuration"
      :source="memberFullscreenSource"
    />
  <!-- </template> -->
  <!-- <FullscreenSpin tip="数据初始化中，请稍等 ..." v-else  loading :mask="false" /> -->
</template>



<script lang="ts" setup>
import { onMounted, onUnmounted, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useAppStore } from '@/store/app'
import { useUserStore } from '@/store/user'
import { useInviteStore } from '@/store/invite'
import { useRouter, useRoute } from 'vue-router'
import { isPC } from '@/utils/common'
import { envConfig } from '@/configs/env'
import { getAndrioInfo, getIOSInfo, getQueryParam, isMobile, reportEvent, isValidIOSNativeInfo, shouldSkipIOSNativeBridge, markIOSNativeSession, fetchIOSTabBarHeight, isMiniAppWebview, syncMiniAppTokenFromQuery, getToken, getMiniAppDeviceParams, removeToken } from '@/utils/auth.ts'
import { getDeviceId } from '@/utils/device'
import * as UserApi from '@/api/user.ts'
import {
  handleNativeTabSwitch,
  OUTLINE_DRAFT_STORAGE_KEY,
} from '@/utils/createDraftCache'
import { ACTIVITY_LOCATION, normalizeActivityLocation } from '@/utils/activityLocation'
import { getActivityModalSize, type ActivityImageSize } from '@/utils/activityModalSize'
import { emitLoginSuccess } from '@/utils/loginEvents'
import { canOpenHomePopup } from '@/utils/homePopupGuard'
import MemberFullscreenModal from '@/components/YiDian/MemberFullscreenModal/index.vue'

const userStore = useUserStore()
const appStore = useAppStore()
const inviteStore = useInviteStore()
const { userInfo } = storeToRefs(userStore)

const route = useRoute()
const router = useRouter()
// if (import.meta.env.MODE !== 'development' && !isMobile()) {
//   window.onbeforeunload = () => false
// }

const memberFullscreenVisible = ref(false)
const memberFullscreenType = ref('Member')
const memberFullscreenSelectDuration = ref(false)
const memberFullscreenSource = ref('')

const getMemberQuery = (type = 'Member', selectDuration: boolean | string = false, source = '') => ({
  memberType: type || 'Member',
  ...(selectDuration ? { selectDuration: 'true' } : {}),
  ...(source ? { source } : {}),
})

const openMemberModal = (data: boolean, type = 'Member', selectDuration: boolean | string = false, source = '') => {
  if (!data) {
    memberFullscreenVisible.value = false
    return
  }
  appStore.setIntegralModal(false)
  if (isMobile()) {
    router.push({
      path: '/m/Member',
      query: getMemberQuery(type, selectDuration, source),
    })
    return
  }
  memberFullscreenType.value = type || 'Member'
  memberFullscreenSelectDuration.value = selectDuration
  memberFullscreenSource.value = source || ''
  memberFullscreenVisible.value = true
}

;(window as any).openMember = openMemberModal

const safeCollectEvent = (eventName: string, payload: Record<string, unknown>) => {
  if (typeof window.collectEvent === 'function') {
    window.collectEvent(eventName, payload)
  }
}

const applyMiniAppAnalyticsProfile = (shortId = '') => {
  if (!isMiniAppWebview()) return
  const uid = shortId || userInfo.value?.shortId || ''
  if (uid) {
    safeCollectEvent('config', {
      user_unique_id: uid,
    })
  }
  safeCollectEvent('profileSet', {
    deviceType: '微信小程序',
    userId: uid,
    prod_name: '1dppt',
  })
}

const token = localStorage.getItem('ydppt_token')
const hasValidChannel = (value: string | null) => value != null && value !== 'null' && value !== ''

const syncChannelFromQuery = () => {
  const channel = getQueryParam('channel')
  if (hasValidChannel(channel)) {
    localStorage.setItem('channel', channel)
  }
}

syncChannelFromQuery()

const setChannelCollectEvent = () => {
  const channel = localStorage.getItem('channel')
  if (!isMobile() && hasValidChannel(channel)) {
    safeCollectEvent('profileSet', {
      activation_channel: channel || '无',
    })
  }
}

const setCollectEvent = ()=>{
  if(!isMobile() && token){
    setTimeout(() => {
      // 添加用户id
      safeCollectEvent('config', { 
           user_unique_id: userInfo.value.shortId,
         })
       safeCollectEvent('profileSet', {
         deviceType:'WEB',
         userId: userInfo.value.shortId, //添加用户id
         prod_name:'1dppt',
      });
     }, 300);
  }
}
const AndroInfo = ()=>{
  try {
    if (isMiniAppWebview()) {
      appStore.setAndrioInfo({
        ...getMiniAppDeviceParams(),
        token: getToken() || '',
      })
      applyMiniAppAnalyticsProfile()
      return
    }
    if (window.JsAndroid) {
      const data = getAndrioInfo();
      appStore.setAndrioInfo(data);
      // console.log('AndrioInfo:', data);
      // 添加用户id
      reportEvent('config', { 
        userId: data.uid
      });
      safeCollectEvent('profileSet', { 
        userId: data.uid, //添加用户id
       })
      reportEvent('profileSet', {
          deviceType:'Android',
      });
    } else if(window.prompt && !isMiniAppWebview()) {
      const currentPath = router.currentRoute.value.path
      if (shouldSkipIOSNativeBridge(currentPath)) {
        window.prompt = null
        return
      }
      setTimeout(()=>{
        const path = router.currentRoute.value.path
        if (shouldSkipIOSNativeBridge(path)) {
          window.prompt = null
          return
        }
        const data = getIOSInfo(path);
        // console.log(data)
        // 非 App WebView（如 Safari）：拿不到 platform=IOS，置空 prompt 避免协议页误判
        // 判断是否为iOS原生端
        if (!isValidIOSNativeInfo(data)) {
          window.prompt = null
          return
        }
        markIOSNativeSession()
        appStore.setAndrioInfo(data);
        const tabHeight = fetchIOSTabBarHeight()
        if (tabHeight != null) {
          appStore.setTabBarHeight(tabHeight)
        }
          // 添加用户id
          reportEvent('config', { 
            userId: data.uid || ''
          });
        safeCollectEvent('profileSet', { 
          userId: data.uid || '', //添加用户id
        })
          reportEvent('profileSet', {
              deviceType:'IOS',
          });
      },500)
    }
  } catch (e) {
    // console.warn('调用 JsAndroid 失败:', e.message);
  }
}

const AUTH_INVALID_CODES = ['AUTHORIZED_EXPIRE', 'UNAUTHORIZED', 'USER_STATUS_ABNORMAL']
const isAuthInvalidCode = (code?: string) => AUTH_INVALID_CODES.includes(String(code || '').trim())
const normalizeNativeLoginState = (value: unknown) => value === true || value === 'true' || value === 1 || value === '1'
const clearUserAuthState = () => {
  removeToken()
  userStore.logout()
  appStore.setAndrioInfo({ token: '', uid: '' })
}

const getUser = ()=>{
  import('@/api/user.ts').then(({ getUserInfo }) => getUserInfo({})).then(res=>{
    if(res.code === 'SUCCESS'){
      userStore.setUserInfo(res.data)
      const shortId = res.data?.shortId
      if (shortId && !isMobile()) {
        safeCollectEvent('profileSet', {
          userId: shortId,
          prod_name:'1dppt',
        })
      }
      if (isMiniAppWebview()) {
        applyMiniAppAnalyticsProfile(shortId || '')
      }
    } else if (isAuthInvalidCode(res.code)) {
      clearUserAuthState()
    }
  }).catch(() => {
    if (!getToken()) clearUserAuthState()
  })
}

//针对原生端返回方法
window.goBack = function() {
  window.ToolsBcak()
}

//针对原生端切tab
window.switchTab = function(tab?: string) {
  handleNativeTabSwitch(tab)
  if (window.getProduction) {
    window.getProduction()
  }
}

let sdkModalRequesting = false
let sdkModalRequestingLocation: string | null = null
let sdkModalPendingLocation: string | null = null
let activeSdkModalLocation = ACTIVITY_LOCATION.HOME
const sdkModalLastRequestedAt: Record<string, number> = {}

const loadActivityImageSize = (url: string) => new Promise<ActivityImageSize | null>((resolve) => {
  if (!url) {
    resolve(null)
    return
  }

  const image = new Image()
  let settled = false
  const finish = (size: ActivityImageSize | null) => {
    if (settled) return
    settled = true
    clearTimeout(timeout)
    image.onload = null
    image.onerror = null
    resolve(size)
  }
  const timeout = setTimeout(() => finish(null), 1500)
  image.onload = () => finish({ width: image.naturalWidth, height: image.naturalHeight })
  image.onerror = () => finish(null)
  image.src = url
})

const openSdkModalWebview = async (url: string, modalList: { content?: string }[], modalLocation: string) => {
  if (!(window as any).JsAndroid && !window.prompt) return false
  const imageUrls = modalList.map(modal => modal?.content).filter((url): url is string => Boolean(url))
  const imageSizes = await Promise.all(imageUrls.map(loadActivityImageSize))
  if (modalLocation !== activeSdkModalLocation) return false
  if (modalLocation === ACTIVITY_LOCATION.HOME && !canOpenHomePopup()) return false
  const { width, height } = getActivityModalSize(imageSizes, window.innerWidth, window.innerHeight)
  const modalUrl = encodeURIComponent(url)
  console.log('触发了几次')
  if ((window as any).JsAndroid) {
    window.location.href = `ydppt://webful?url=${modalUrl}&w=${width}&h=${height}&modal=true&dim=true&closeBtn=false`
    return true
  }
  if (window.prompt) {
    window.location.href = `ydppt://webful?url=${modalUrl}&w=${width}&h=${height}&modal=false&dim=true&closeBtn=false`
    return true
  }
  return false
}

// 弹窗展示位置和对应的路由
const pathTolocation ={
  'HOME':'/m/home',
  'MEMBER':'/m/Member',
  'TEMPLATE':'/m/Template',
  'WORKS':'/m/Production',
}

// 原生打开活动弹窗
window.openSdkModal = async function(location = ACTIVITY_LOCATION.HOME) {
  const modalLocation = normalizeActivityLocation(location)
  if (modalLocation === ACTIVITY_LOCATION.HOME && !canOpenHomePopup()) return false
  activeSdkModalLocation = modalLocation
  const now = Date.now()
  const lastRequestedAt = sdkModalLastRequestedAt[modalLocation] || 0
  if (sdkModalRequesting) {
    sdkModalPendingLocation = sdkModalRequestingLocation === modalLocation ? null : modalLocation
    return false
  }
  if (now - lastRequestedAt < 1000) return false

  sdkModalRequesting = true
  sdkModalRequestingLocation = modalLocation
  sdkModalLastRequestedAt[modalLocation] = now
  try {
    const res = await UserApi.getModalListByLocation({
      params: {
        location: modalLocation
      }
    })
    const modalList = Array.isArray(res?.data) ? res.data : []
    if (res?.code !== 'SUCCESS' || modalList.length === 0) return false
    if (modalLocation !== activeSdkModalLocation) return false

    const activityInfo = {
      location: modalLocation,
      modalList
    }
    appStore.setActivityInfo(activityInfo)
    localStorage.setItem('activityInfo', JSON.stringify(activityInfo))

    const url = `${window.location.origin}/activities?location=${encodeURIComponent(modalLocation)}`
    // if(window.location.pathname == pathTolocation[modalLocation])
      return await openSdkModalWebview(url, modalList, modalLocation)
  } catch {
    return false
  } finally {
    setTimeout(() => {
      sdkModalRequesting = false
      sdkModalRequestingLocation = null
      const pendingLocation = sdkModalPendingLocation
      sdkModalPendingLocation = null
      if (pendingLocation && pendingLocation === activeSdkModalLocation) {
        window.openSdkModal?.(pendingLocation)
      }
    }, 1000)
  }
}

window.openMySdkModal = function() {
  return window.openSdkModal(ACTIVITY_LOCATION.MINE)
}

//登录状态发生变化
window.loginStateChanged = function(isLogin){
  console.log('loginStateChanged', isLogin)
  const nativeLoggedIn = normalizeNativeLoginState(isLogin)
  if(nativeLoggedIn){
    AndroInfo()
    emitLoginSuccess({ source: 'native' })
    getUser()
    window.openSdkModal?.(ACTIVITY_LOCATION.HOME)
  } else {
    clearUserAuthState()
  }
  if(window.getProduction){
    window.getProduction()
  }
  if(window.getHome){
    window.getHome()
  }
  //这个是ios临时在会员页监听登录成功方法
  if(window.iosLinCatarog){
    window.iosLinCatarog()
  }
}


// 统一处理“充值成功”的逻辑（localStorage 标记 + 页面级回调）
const handleRechargeSuccess = () => {
  const flag = localStorage.getItem('rechargeSuccess')
  if (!flag) return

  // 全局刷新用户信息
  getUser()
  // 用一次就清掉，避免重复触发
  setTimeout(()=>{
    localStorage.removeItem('rechargeSuccess')
  },1000)
}

//设置根节点字体大小
const setRem = ()=>{
  const doc = document.documentElement;
  const baseSize = 16; // PC 默认字体大小
  const scale = doc.clientWidth / 1920; // PC 宽度比例
  // 判断是否为移动端
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  if (isMobile) {
    // 设置移动端字体大小
    const mobileBaseSize = 375; // 移动端默认字体大小
    const mobileScale = doc.clientWidth / mobileBaseSize;
    doc.style.fontSize = baseSize * mobileScale + 'px';
    doc.style.scrollbarWidth = 'none'
  } else {
    // PC 设置字体大小
    doc.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
  }
}


// storage 事件：用于监听“其它 WebView / 窗口”写入的充值标记
const handleStorageChange = (e: StorageEvent) => {
  if (e.key === 'rechargeSuccess' && e.newValue) {
    handleRechargeSuccess()
  }
  if (e.key === OUTLINE_DRAFT_STORAGE_KEY && e.newValue) {
    handleNativeTabSwitch()
  }
}

const handleVisibilityChange = () => {
  if (document.visibilityState === 'visible') {
    handleNativeTabSwitch()
  }
}


onMounted(async () => {
  // const slides = await api.getMockData('slides')
  // slidesStore.setSlides(slides)

  if (route.path === '/m/application/create') {
    const title = Array.isArray(route.query.title) ? route.query.title[0] : route.query.title
    document.title = title || '应用生成'
  } else {
    document.title = envConfig.appTitle
  }
  inviteStore.cacheInviteCodeFromCurrentUrl(route.query.code || route.query.inviteCode)
  const miniToken = syncMiniAppTokenFromQuery()
  // 小程序未登录（URL token 为空）时，同步清掉 H5 用户态
  if (isMiniAppWebview() && !miniToken) {
    userStore.logout()
    appStore.setAndrioInfo({ token: '' })
  }

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  if(isMobile()){
    if(!isIOS){
      if (!isMiniAppWebview()) {
        window.prompt = null;
      }
      AndroInfo();
    } else if (shouldSkipIOSNativeBridge(route.path)) {
      // window.prompt = null;
    } else {
      AndroInfo();
    }
    // 小程序已登录时拉用户信息并绑定埋点 userId
    if (isMiniAppWebview() && (miniToken || getToken())) {
      getUser()
    }
  } else {
    window.prompt = null;
    getDeviceId()
    setChannelCollectEvent()
    setCollectEvent()
  }
  
  // 初始化编辑器和移动端页面
  if (route.path === '/editor' || route.path === '/mobile') {
    const [{ deleteDiscardedDB }, { useSnapshotStore }] = await Promise.all([
      import('@/utils/database'),
      import('@/store/snapshot'),
    ])
    await deleteDiscardedDB()
    useSnapshotStore().initSnapshotDatabase()
  }

  // setRem();
  // window.addEventListener('resize', setRem);

  // 处理移动端页面逻辑
  if (isMobile()) {
    window.addEventListener('storage', handleStorageChange);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // 处理充值成功逻辑
    handleRechargeSuccess()
  }
})

// 处理iOS桥接路由策略
const applyIOSBridgeRoutePolicy = (path: string) => {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
  if (!isMobile() || !isIOS || isMiniAppWebview()) return
  if (shouldSkipIOSNativeBridge(path)) {
    window.prompt = null
  }
}

watch(
  () => route.path,
  (path) => applyIOSBridgeRoutePolicy(path),
)

onUnmounted(() => {
  if (isMobile()) {
    window.removeEventListener('storage', handleStorageChange);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  }
  // window.removeEventListener('resize', setRem);
})

</script>

<style lang="scss">
#app {
  height: 100%;
}
// @media screen and (min-width: 768px) {
    /* 默认使用默认字体大小*/
  body {
    font-weight: 500; /* 默认使用默认字体大小 */
  }
  @font-face {
    font-family: 'GwbFont';
    src: url('./assets/fonts/AlibabaPuHuiTi-Light.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'GwbFont';
    // src: url('https://ptos.1dppt.com/web/fonts/Alibaba-PuHuiTi-Regular-CdxnY8Z2.woff2') format('woff2');
    src: url('./assets/fonts/Alibaba-PuHuiTi-Regular.ttf') format('truetype');
    font-weight: 500; 
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: 'GwbFont';
    src: url('./assets/fonts/Alibaba-PuHuiTi-Medium.ttf') format('truetype');
    font-weight: 600; 
    font-style: normal;
    font-display: swap;
  }
// }
</style>

